import React, { useState, useEffect, Suspense, lazy, Component, ReactNode } from 'react';

const ChatWidget = lazy(() => import('./ChatWidget'));

class BotErrorBoundary extends Component<{ children: ReactNode }, { crashed: boolean }> {
  state = { crashed: false };
  static getDerivedStateFromError() {
    return { crashed: true };
  }
  render() {
    return this.state.crashed ? null : this.props.children;
  }
}

export default function AIAssistant() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Puppeteer (react-snap) headless Chrome is detected via webdriver flag OR UA string.
    // Old headless Chrome (Puppeteer <3) sets "HeadlessChrome" in the UA.
    const isHeadless =
      navigator.webdriver ||
      /HeadlessChrome/.test(navigator.userAgent);
    if (!isHeadless) {
      setMounted(true);
    }
  }, []);

  if (!mounted) return null;

  return (
    <BotErrorBoundary>
      <Suspense fallback={null}>
        <ChatWidget />
      </Suspense>
    </BotErrorBoundary>
  );
}
